/**
 * 这个文件作为组件的目录
 * 目的是统一管理对外输出的组件，方便分类
 */
/**
 * 布局组件
 */

import { AvatarName, Question, SelectLang, ThemeToggle } from '@zhiyue/core';

import AvatarDropdown from './AvatarDropdown';
import Footer from './Footer';
import NotificationIcon from './NotificationIcon';
import PlatformThemeBoundary, {
  applyNavTheme,
  getNavigationToken,
  useIsDarkMode,
} from './PlatformTheme';

export {
  AvatarDropdown,
  AvatarName,
  Footer,
  NotificationIcon,
  PlatformThemeBoundary,
  applyNavTheme,
  getNavigationToken,
  useIsDarkMode,
  Question,
  SelectLang,
  ThemeToggle,
};
